export default "__VITE_ASSET__CjpVvUsV__"